/**
 * Debounces a function on a set interval, defaults to 0.5 seconds.
 */
export const debounce = <T extends (...args: unknown[]) => unknown>(fn: T, ms: number = 500) => {
  let timeout: ReturnType<typeof setTimeout>;
  
  const debounced = (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), ms);
  };
  
  debounced.cancel = () => {
    clearTimeout(timeout);
  };
  
  return debounced;
};
